import { useEffect, useState } from 'react';
import { meetRegels, volgMeetlog } from '../lib/meetlog';

/**
 * Het verslag van het meetlog, onder het gesprek. Alleen met `?meet=1`.
 *
 * Zo hoog als het verslag zelf, net als op de meetpagina: een vak met een
 * eigen scrollbalk was op een telefoon niet te fotograferen. Nu scrolt de
 * hele pagina en zijn een paar screenshots genoeg.
 *
 * ALLEEN NEDERLANDS. Gereedschap voor Giovanni; een gast ziet dit nooit.
 */
export default function Meetvak() {
  const [regels, setRegels] = useState<readonly string[]>(() => meetRegels());
  const [kopieStand, setKopieStand] = useState('');

  useEffect(() => volgMeetlog((r) => setRegels([...r])), []);

  async function kopieer(): Promise<void> {
    try {
      await navigator.clipboard.writeText(regels.join('\n'));
      setKopieStand('Gekopieerd.');
    } catch {
      setKopieStand('Kopiëren lukte niet. Maak screenshots.');
    }
  }

  return (
    <div className="mt-3 border-t-2 border-gio-orange/40 pt-2">
      <div className="flex items-center justify-between mb-1">
        <p className="text-[11px] font-bold text-gio-dark">
          Meetlog geluid <span className="font-normal text-slate-450">(alleen met ?meet=1)</span>
        </p>
        <button
          type="button"
          onClick={() => void kopieer()}
          className="text-[10px] font-bold px-2 py-1 rounded-lg bg-gio-blue text-white"
        >
          Kopieer
        </button>
      </div>
      {kopieStand !== '' && <p className="text-[10px] text-slate-550 mb-1">{kopieStand}</p>}
      <textarea
        readOnly
        value={regels.join('\n')}
        rows={Math.max(6, regels.length + 1)}
        className="w-full text-[10px] font-mono leading-snug p-2 border-2 border-slate-250 rounded-xl
                   bg-slate-50 text-slate-650"
      />
    </div>
  );
}
